import { useSwrFetch } from "hooks";

import { ShipperShipmentQATab } from "./ShipperShipmentQATab";

interface Props {
  shipment: CondensedShipment | undefined;
}

export function ShipperShipmentQATabContainer(props: Props) {
  const { shipment } = props;

  const url = shipment != null ? `/shipments/${shipment.info.id}/qa` : null;

  const { data, loading, error } = useSwrFetch<ShipmentQA[]>({
    url,
    errorMessage: "Failed to fetch shipment Q&A",
  });

  if (!shipment) {
    return null;
  }

  return (
    <ShipperShipmentQATab
      loading={loading}
      error={error}
      qaList={data ?? []}
      shipment={shipment}
    />
  );
}
